module.exports = __webpack_public_path__ + "img/train_stroke.a2ddeb61.svg";